import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { KeyRoundIcon } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function PasswordChangeModal({ open, onDone }) {
  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (pw1.length < 6) return toast.error("A senha precisa ter pelo menos 6 caracteres");
    if (pw1 !== pw2) return toast.error("As senhas não conferem");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { new_password: pw1 });
      toast.success("Senha atualizada!");
      onDone?.();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open}>
      <DialogContent
        className="bg-[#14151A] border-border rounded-none max-w-md [&>button.absolute]:hidden"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
        data-testid="pw-modal"
      >
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 bg-[#FFD60A] flex items-center justify-center">
              <KeyRoundIcon className="w-5 h-5 text-black" />
            </div>
            <DialogTitle className="font-display text-2xl">Troca de senha obrigatória</DialogTitle>
          </div>
          <div className="text-xs text-muted-foreground">
            É o seu primeiro acesso (ou sua senha foi resetada pelo administrador). Defina uma senha pessoal e segura para continuar.
          </div>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div>
            <Label className="text-[11px] uppercase tracking-wider text-muted-foreground">Nova senha</Label>
            <Input data-testid="pw-new1" type="password" value={pw1} onChange={(e) => setPw1(e.target.value)} className="mt-1 rounded-none bg-[#0A0A0C] font-mono h-11" />
          </div>
          <div>
            <Label className="text-[11px] uppercase tracking-wider text-muted-foreground">Confirmar nova senha</Label>
            <Input data-testid="pw-new2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="mt-1 rounded-none bg-[#0A0A0C] font-mono h-11" />
          </div>
        </div>
        <Button
          onClick={submit}
          disabled={busy}
          data-testid="pw-submit"
          className="rounded-none bg-[#FFD60A] text-black hover:bg-[#FFD60A]/85 font-bold uppercase tracking-wider text-xs h-11 w-full"
        >
          {busy ? "Salvando..." : "Salvar nova senha"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
